// extracted by mini-css-extract-plugin
export default {"input":"input_input__mKA96","error":"input_error__AWS07"};